import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ContactUserService} from "../services/contact-user.service";
import {ContactUser} from "../models/ContactUser";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  contactForm!: FormGroup;
  message = '';

  constructor(private formBuilder: FormBuilder,
              private contactUserService: ContactUserService) {
  }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', Validators.required],
      companyName: [''],
      message: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.contactForm.invalid) {
      return;
    } else {
      const contactUser = this.contactForm.getRawValue() as ContactUser;
      contactUser.email = contactUser.email.toLowerCase().trim();
      this.contactUserService.save(contactUser).pipe().subscribe(() => {
        this.contactForm.reset();
      });
    }
  }
}
